import { QueryObserverResult, useQuery } from '@tanstack/react-query';

import { API_QUERY_KEYS, getResponses, GetResponsesResponse, QueryDefaults } from 'api';

export const useResponses = (
  consultationId: number
): QueryObserverResult<GetResponsesResponse> =>
  useQuery(
    [API_QUERY_KEYS.getResponses, consultationId],
    () => getResponses(consultationId),
    QueryDefaults
  );
